// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"AssistedBookingStatusModal__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AssistedBookingStatus/AssistedBookingStatusModal.scss
 ** module id = 885
 ** module chunks = 1
 **/